<template>
  <div :class="['textarea-input',classField]">
    <label :for="'textarea-'+uuid" class="subtitle-2 black--text pl-3">
      {{ field.label }}
      <span v-if="this.field.required==1" class="orange--text text--darken-3">*</span>
    </label>
    <textarea
      @change="update()"
      v-model.lazy="model"
      :id="'text-'+uuid"
      :placeholder="field.config.placeholder"
    />
    <div class="hint" v-if="field.hint">{{field.hint}}</div>
  </div>
</template>

<script>
import FieldMixin from "./FieldMixin";
export default {
  mixins: [FieldMixin],
  name: "FieldTextarea",

  methods: {
    validate: function() {
      if (this.field.required === 1 && !this.model) {
        this.isValid = false;
        this.addError(this.block.id,"Champ obligatoire");

      } else {
        this.isValid = true;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.textarea-input {
  width: 90%;
  textarea {
    background-color: #e8e8e8;
    color: #0a252c;
    box-shadow: none;
    font-size: 0.8rem;
    padding: 0.5rem;
    border-radius: 15px;
    border: 1px solid transparent;
    -webkit-transition: 0.5s;
    transition: 0.5s;
    width: 100%;
    &:focus {
      border: 1px solid #888;
    }
  }
  &.error {
    textarea {
      border: 1px solid red;
    }
  }
}
</style>
